module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "absence-reasons text-dark pad-1"
  }, [_c('div', {
    staticClass: "absence-reasons__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.i18n['absence_reasons']))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'bottom'
      }),
      expression: "{\n                  arrow: true,\n                  placement : 'bottom'\n                }"
    }],
    staticClass: "do-bttn do-bttn--submit",
    attrs: {
      "content": '<p class=' + 'tooltip-shortcut' + '>' + _vm.$t('vue2.common.press') + '<span>N</span></p>'
    },
    on: {
      "click": function($event) {
        return _vm.setIsCreateAbsenceReason(true)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.i18n['create_absence']) + "\n    ")])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader') : [(_vm.absenceReasonsActive.length === 0) ? _c('h2', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.i18n['no_absence_reasons_created']))]) : _c('AbsenceReasonsTable', {
    attrs: {
      "items": _vm.absenceReasonsActive,
      "isAbsenceRequestActivated": _vm.isAbsenceRequestActivated,
      "isAbsenceIntegrationActive": _vm.isAbsenceIntegrationActive,
      "absenceCodes": _vm.absenceCodes,
      "sdAbsenceCodes": _vm.sdAbsenceCodes,
      "salarySystem": _vm.salarySystem
    },
    on: {
      "editAbsencePrivate": _vm.editAbsencePrivate,
      "editAbsenceCanRequest": _vm.editAbsenceCanRequest,
      "editAbsenceOngoing": _vm.editAbsenceOngoing,
      "editAbsenceCode": _vm.editAbsenceCode,
      "toggleArchived": _vm.toggleArchived
    }
  }), _vm._v(" "), (_vm.absenceReasonsArchived.length > 0) ? _c('p', {
    staticClass: "text-link marg-1-top",
    on: {
      "click": function($event) {
        _vm.isShowArchived = !_vm.isShowArchived
      }
    }
  }, [_vm._v(_vm._s(_vm.isShowArchived ? _vm.i18n['hide_archived'] : _vm.i18n['show_archived']) + "\n      " + _vm._s('(' + _vm.absenceReasonsArchived.length + ')'))]) : _vm._e(), _vm._v(" "), (_vm.isShowArchived && _vm.absenceReasonsArchived.length > 0) ? _c('AbsenceReasonsTable', {
    attrs: {
      "items": _vm.absenceReasonsArchived,
      "isAbsenceRequestActivated": _vm.isAbsenceRequestActivated,
      "isAbsenceIntegrationActive": _vm.isAbsenceIntegrationActive,
      "absenceCodes": _vm.absenceCodes,
      "sdAbsenceCodes": _vm.sdAbsenceCodes,
      "salarySystem": _vm.salarySystem
    },
    on: {
      "editAbsencePrivate": _vm.editAbsencePrivate,
      "toggleArchived": _vm.toggleArchived
    }
  }) : _vm._e()], _vm._v(" "), (_vm.isCreateAbsenceReason) ? _c('AbsenceReasonsCreate', {
    attrs: {
      "absenceCodes": _vm.absenceCodes,
      "sdAbsenceCodes": _vm.sdAbsenceCodes,
      "isAbsenceIntegrationActive": _vm.isAbsenceIntegrationActive,
      "salarySystem": _vm.salarySystem
    },
    on: {
      "create": _vm.handleCreateReason,
      "cancel": function($event) {
        return _vm.setIsCreateAbsenceReason(false)
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a15b7f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AbsenceReasons/AbsenceReasons.vue
// module id = 1824
// module chunks = 1